import Flex from 'UIKit/Box/Flex'
import { BoxProps } from 'UIKit/Box/types'
import { BonusStatusEnums } from 'config/types/bonus'
import { UserBonus } from 'config/types/bonus/userBonus'
import React from 'react'
import styled from 'styled-components'
import AvailableBonusContent from 'views/BonusCenter/components/BonusItem/BonusContent/AvailableBonusContent'
import UsedBonusContent from 'views/BonusCenter/components/BonusItem/BonusContent/UsedBonusContent'
import { useBonusLogic } from 'views/BonusCenter/hooks'
import ActiveBonusContent from './components/ActiveBonusContent'
import BonusItemLayout from './components/BonusItemLayout'

interface BonusItemProps {
  bonus: UserBonus
}

const BonusItem: React.FC<BonusItemProps & BoxProps & { onDismiss?: () => void }> = ({
  bonus,
  onDismiss = () => {},
  ...props
}) => {
  const { handleBonusUsed, bonusInstance } = useBonusLogic(bonus)

  return (
    <StyledContainer onDismiss={onDismiss} bonus={bonus} {...props}>
      <Flex zIndex="2" height="100%" flexDirection="column" justifyContent="space-between">
        {bonus && bonus.status === BonusStatusEnums.Available && (
          <AvailableBonusContent bonus={bonusInstance} onBonusSubmitted={handleBonusUsed} />
        )}

        {bonus && bonus.status === BonusStatusEnums.Active && <ActiveBonusContent bonus={bonusInstance} />}
        {bonus && (bonus.status === BonusStatusEnums.Used || bonus.status === BonusStatusEnums.Invalid) && (
          <UsedBonusContent bonus={bonusInstance} />
        )}
      </Flex>
    </StyledContainer>
  )
}

const StyledContainer = styled(BonusItemLayout)`
  min-width: 200px;
  height: 100%;
`

export default BonusItem
